import React from "react";
import YoutubeVideoCtrl from './YoutubeVideoCtrl';

import { getText } from 'Common/utility/utils.js';

export default class YoutubeVideo extends React.Component {
  render() {
    const config = this.props.config;
    if (!config) {
      return 'Loading';
    }

    const src = getText(config, 'src');
    const title = (config.querySelector('richtitle') || config.querySelector('title') || {}).innerHTML;
    const subtitle = (config.querySelector('subtitle') || {}).innerHTML;
    const description = (config.querySelector('description') || {}).innerHTML;
    const id = config.id ? config.id : undefined;
    const background = config.dataset.background;

    return (
      <YoutubeVideoCtrl id={id} background={background} src={src} title={title} subtitle={subtitle} description={description}/>
    );
  }
}
